import React, { useContext } from 'react';
import SendGridLink from '../SendGridLink';
import SgTwilioLogoSvg from '../../assets/svg/nav/sg-twilio-logo.svg';
import GlobalContext from '../../context/global';
import { startFree } from '../../utils/pricing';
import MenuLink from './MenuItem/Link';
import {
  StyledMaintenanceNavigation,
  StyledLogo,
  StyledSecondaryMenu,
  StyledCta,
} from './styles';

const MaintenanceNavigation = () => {
  const { user } = useContext(GlobalContext);
  return (
    <StyledMaintenanceNavigation>
      <StyledLogo>
        <SgTwilioLogoSvg />
      </StyledLogo>
      <StyledSecondaryMenu>
        {user.userid ? (
          <MenuLink label="Dashboard" url="https://app.sendgrid.com" />
        ) : (
          <MenuLink label="Sign In" url="https://app.sendgrid.com/login" />
        )}
      </StyledSecondaryMenu>
      <StyledCta>
        {user.userid ? (
          <a href="https://support.sendgrid.com">Support</a>
        ) : (
          <button type="button" onClick={startFree}>
            Try for free
          </button>
        )}
      </StyledCta>
    </StyledMaintenanceNavigation>
  );
};

export default MaintenanceNavigation;
